export default __webpack_public_path__ + "static/media/chakraone.699a2240.ico";